import React, { useState } from "react";
import { IconButton } from "@mui/material";
import PageviewIcon from "@mui/icons-material/Pageview";
import { DeleteConfirmation } from "../../common/GenericDeleteConfirmationDialog/DeleteConfirmationDialog";
import { VanillaJSONEditor } from "../../common";

const TrailLogsEventArguments = ({rowData}) => {
    const [defaultDialogState, setDefaultDialogState] = useState({
        open: false,
        rowData: null,
    });

    return (
        <>
            <DeleteConfirmation
                DELETE_TEXT={``}
                customTitle={`Event Arguments (${defaultDialogState?.rowData?.requestId})`}
                defaultSelected={[]}
                isConfirmationOnly={true}
                handleDelete={() =>
                    setDefaultDialogState({ open: false, rowData: null })
                }
                defaultDeleteState={defaultDialogState}
                hideDeleteBtn={true}
                handleClose={() =>
                    setDefaultDialogState({ open: false, rowData: null })
                }
            >
                <VanillaJSONEditor
                    content={{
                        json: defaultDialogState?.rowData?.eventArguments || [],
                    }}
                    readOnly={false}
                    navigationBar={false}
                    statusBar={false}
                    mainMenuBar={false}
                />
            </DeleteConfirmation>
            <IconButton
                aria-label="edit"
                size="small"
                onClick={() =>
                    setDefaultDialogState({
                        open: true,
                        rowData: {
                            eventArguments: rowData?.eventArguments,
                            requestId: rowData?.requestId,
                        },
                    })
                }
            >
                <PageviewIcon />
            </IconButton>
        </>
    );
};

export default TrailLogsEventArguments;
